import styled from 'styled-components';

const Logo = styled.img``;

export default Logo;
